import Mock from 'mockjs'

// 供应商商品上架列表
const MOCK030010 = Mock.mock({
    'respCode': '0000',
    'respMsg': '',
    'respData': {
        'spuInfos|10-20': [{
            'spuId': '@id',
            'spuName': '@cword(20)',
            'spuAttach': '@image("600x600",#b7ef7c)',
            'model': '@cword(10)',
            'minPriceA|1000-2000': 1000,
            'maxPriceA|2000-3000': 2000,
            'minPriceD|3000-4000': 3000,
            'maxPriceD|4000-5000': 4000,
            'salesVolume|100-1000': 100,
            'categoryId': '@id',
            'categoryName': '@cword(20)',
            'upTime': '@date',
            'status': 2
        }],
        'categoryInfos|2-10': [{
            'categoryId': '@id',
            'categoryName': '@cname(2-10)'
        }],
        'totalCount|100-500': 100
    }
});

export default MOCK030010


// WEBPACK FOOTER //
// ./src/mock/getVendorProductOnline.js